import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';


const routes: Routes = [
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './modules/agent/agent.module#AgentModule'
      }
    ]
  },
  {
    path: 'admin',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './modules/admin/admin.module#AdminModule'
      }
    ]
  },            
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './modules/community/community.module#CommunityModule'
      }
    ]
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './modules/message-center/message-center.module#MessageCenterModule'
      }
    ]
  },
  { path: "**", redirectTo: "", pathMatch: 'full' }
];

@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
